document.addEventListener('DOMContentLoaded', function () {

  const selector = document.querySelector('.sodini-price-selector');

  const button = selector?.querySelector('#SodiniPriceButton');
  const dropdown = selector?.querySelector('#SodiniPriceDropdown');
  const label = selector?.querySelector('#SodiniPriceLabel');

  function updatePrices(mode) {

    const isRetail = mode === 'ret';

    document.querySelectorAll('.sodini-price-display').forEach(function (box) {

      const whls = box.querySelector('.sodini-price-whls');
      const ret = box.querySelector('.sodini-price-ret');

      if (!whls || !ret) return;

      whls.style.display = isRetail ? 'none' : 'inline';
      ret.style.display = isRetail ? 'inline' : 'none';

    });

    if (label) {
      label.textContent = isRetail ? 'RET' : 'WHLS';
    }

    document.querySelectorAll('[data-price-mode]').forEach(function (option) {
      option.setAttribute(
        'aria-pressed',
        String(option.dataset.priceMode === mode)
      );
    });

  }

  const savedMode = localStorage.getItem('sodini-price-mode') === 'ret'
    ? 'ret'
    : 'whls';

  updatePrices(savedMode);

  // Menu desktop
  if (button && dropdown && selector) {

    button.addEventListener('click', function (event) {

      event.stopPropagation();

      const isOpen = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', String(!isOpen));
      dropdown.hidden = isOpen;

    });

    document.addEventListener('click', function (event) {

      if (!selector.contains(event.target)) {
        dropdown.hidden = true;
        button.setAttribute('aria-expanded', 'false');
      }

    });

  }

  // Selezione WHLS / RET su desktop e mobile
  document.querySelectorAll('[data-price-mode]').forEach(function (option) {

    option.addEventListener('click', function () {

      const mode = option.dataset.priceMode;

      if (mode !== 'whls' && mode !== 'ret') return;

      localStorage.setItem('sodini-price-mode', mode);

      updatePrices(mode);

      // Chiude il dropdown desktop
      if (dropdown && button) {
        dropdown.hidden = true;
        button.setAttribute('aria-expanded', 'false');
      }

      // Chiude il sottomenu mobile
      const mobileSelector = option.closest('.sodini-mobile-price-selector');

      if (mobileSelector) {
        mobileSelector.open = false;
      }

    });

  });

  // Pulsante indietro del sottomenu mobile
  document.querySelectorAll('.sodini-mobile-price-selector .menu-drawer__close-button')
    .forEach(function (backButton) {

      backButton.addEventListener('click', function () {
        const mobileSelector = backButton.closest('.sodini-mobile-price-selector');

        if (mobileSelector) {
          mobileSelector.open = false;
        }
      });

    });

});